// extracted by mini-css-extract-plugin
export default {"container":"Risk_container__bEbis","mainTitle":"Risk_mainTitle__9Bp3u","title":"Risk_title__n1Hvn","button":"Risk_button__TugSQ"};